class objectHelper {
    copy(obj) {
		return JSON.parse(JSON.stringify(obj));
	}
}

export default new objectHelper;